export const Tabs = () => {

  $('ul.js-tab-list').on('click', 'li:not(.active)', function() {
    $(this)
      .addClass('active').siblings().removeClass('active')
      .closest('div.js-tab').find('div.js-tab-content').removeClass('active').eq($(this).index()).addClass('active');
  });
};
